<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
        <h4 class="page-title">
          <i class="fas fa-layer-group"></i>
          {{tag}} 행위
        </h4>
        <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
            <a href="#">
              <i class="fas fa-home text-muted"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="font_15" href="#">로그</a>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a class="font_15 font-weight-bold" href="#">행위</a>
          </li>
        </ul>
      </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              {{tag}} 로그 상세 정보
            </div>
            <div class="mb7">
              날짜 : {{model.created_at | datetime}}
            </div>
          </div>
          <hr>
          <b-row class="mb-4">
            <b-col v-if="model.user_id && tag == 'USER'">
              <b-button block size="sm" class="float-right" variant="info" @click="is_modal = true">사용자 정보 보기</b-button>
            </b-col>
            <!-- <b-col v-if="model.user_id && tag == 'USER'">
              <b-button block size="sm" class="float-right" variant="info" @click="is_modal = true">View Group</b-button>
            </b-col> -->
            <b-col v-if="model.partner_id && tag == 'PARTNER'">
              <b-button block size="sm" class="float-right" variant="warning" @click="is_modal = true">파트너 정보 보기</b-button>
            </b-col>
            <b-col v-if="model.admin_id && tag == 'ADMIN'">
              <b-button block size="sm" class="float-right" variant="primary" @click="is_modal = true">관리자 정보 보기</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_username">사용자명</label>
                <b-form-input md=5 type="text" id="ph_username" :disabled="lock" v-model="model.username"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_action">행위</label>
                <b-form-input md=5 type="text" id="ph_action" :disabled="lock" v-model="model.action"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_addr">주소</label>
                <b-form-input md=5 type="text" id="ph_addr" :disabled="lock" v-model="model.action"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_addr_all">주소 전체</label>
                <b-form-input md=5 type="text" id="ph_addr_all" :disabled="lock" v-model="model.addr_all"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-4 mb-4">
            <b-col>
              <b-button class="btn btn-sm btn-add btn-block float-right" block size="sm">클라이언트 요청 데이터</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <pre>
                <JsonViewer
                v-if="model.info"
                :value="model.info"
                :expand-depth=5
                copyable
                boxed
                sort
                />
              </pre>
            </b-col>
          </b-row>
          <b-button size="sm" class="float-right" variant="primary" @click="list">목록</b-button>
        </b-card>
      </b-col>
    </b-row>
    <!-- 정보성 모달 영역 -->
    <b-modal size="xl" title="정보"  v-model="is_modal" class="modal-dialog modal-dialog-centered" hide-footer>
      <User v-if="model.user_id && tag == 'USER'" :user_id="model.user_id" />
      <Partner v-if="model.partner_id && tag == 'PARTNER'" :partner_id="model.partner_id" />
      <Admin v-if="model.admin_id && tag == 'ADMIN'" :admin_id="model.admin_id" />
      <b-button class="mt-3 float-right" @click="is_modal = false" variant="info">확인</b-button>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>